var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32009_1413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32009_1413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 10.0007C19.9994 4.47747 15.522 0 9.99875 0C4.47552 0 -0.00195312 4.47747 -0.00195312 10.0007C-0.00195312 14.6908 3.22687 18.6262 7.58282 19.7069V13.0568H5.52059V10.0007H7.58282V8.68385C7.58282 5.27993 9.12324 3.70222 12.4651 3.70222C13.0986 3.70222 14.1919 3.82643 14.6391 3.95068V6.72103C14.4031 6.69619 13.9931 6.68375 13.4837 6.68375C11.8439 6.68375 11.2103 7.30491 11.2103 8.9199V10.0007H14.4769L13.9157 13.0568H11.2103V19.9282C16.1621 19.3301 19.9994 15.1138 19.9994 10.0007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9166 13.0577L14.4778 10.0016H11.2112V8.92081C11.2112 7.30582 11.8448 6.68469 13.4846 6.68469C13.994 6.68469 14.4039 6.69709 14.64 6.72194V3.95162C14.1928 3.82737 13.0995 3.70312 12.466 3.70312C9.12418 3.70312 7.58371 5.28088 7.58371 8.68479V10.0016H5.52148V13.0577H7.58371V19.7078C8.35748 19.8998 9.16654 20.0023 9.99964 20.0023C10.4098 20.0023 10.814 19.9771 11.2112 19.9291V13.0577H13.9166Z",
    fill: "#C6CBD9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebook_white.6f788132b47052657cb31feba875322a.svg";
export { ForwardRef as ReactComponent };